import { art } from "./sprites";

/**
 * The icon for a file slot, chosen by what it accepts — `editable-file-slots`
 * FR-19, FS-D6.
 *
 * Slots are creator data, so a format is recognised by its extensions, never
 * by its creator-editable short name. Only PDF and Guitar Pro have sprites;
 * everything else gets `undefined` and the caller draws text instead. Showing
 * the Guitar Pro icon on a MIDI file, as every call site used to, is the bug
 * this exists to stop.
 */
const GP_EXTENSIONS = [".gp", ".gp5", ".gpx", ".gp7"];

export function formatIcon(accept: readonly string[]): string | undefined {
  const lower = accept.map((a) => a.toLowerCase());
  if (lower.includes(".pdf")) return art.pdf;
  if (lower.some((a) => GP_EXTENSIONS.includes(a))) return art.gp;
  return undefined;
}
